import { useEffect } from "react";

export interface ExtendedWindow extends Window {
  dataLayer?: {
    event: string;
    event_name: string;
    is_popup_open: boolean;
    frontend_error_code?: string;
    backend_error_code?: number;
  }[];
}

type PopupProps = {
  isPopupOpen?: boolean;
  frontendErrorCode?: string;
  backendErrorCode?: number;
};

const useGtmTurnstilePopup = (props: PopupProps) => {
  const { isPopupOpen, frontendErrorCode, backendErrorCode } = props;

  useEffect(() => {
    const triggerPopup = () => {
      const extendedWindow = window as ExtendedWindow;
      extendedWindow.dataLayer = extendedWindow.dataLayer ?? [];
      extendedWindow.dataLayer.push({
        event: "popup",
        event_name: "turnstile_pop_up",
        is_popup_open: isPopupOpen ?? false,
        frontend_error_code: frontendErrorCode ?? undefined,
        backend_error_code: backendErrorCode ?? undefined,
      });
    };

    if (isPopupOpen) triggerPopup();

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default useGtmTurnstilePopup;
